import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Table, TableHead, TableBody, TableRow, TableCell, Typography, Link } from '@airbus/components-react/components'
import { Workorder } from 'types/workorder/workorder'
import LocalStorage from 'utils/myLocalStorage'

type Props = {
  workorders: Workorder[]
  isDisplayMode: boolean
}

const TechlogWorkorders = ({ workorders, isDisplayMode }: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const hasWoPermissions = LocalStorage.getOrDefault(
    [LocalStorage.KEY_PERMISSIONS, 'AMSWEB_ACCESS_MAOE-DSP'],
    LocalStorage.VALUE_TYPE.BOOLEAN,
    false,
  )

  return (
    <>
      {workorders && workorders.length > 0 ? (
        <div>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>{t('9510068')}</TableCell>
                <TableCell>{t('9500025')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {workorders.map((row, i: number) => (
                <TableRow key={'workorder' + i} hover={true} style={{ cursor: 'pointer' }}>
                  <TableCell>
                    <div className='table_data_truncate_1_line' title={row.requestedWork}>
                      {row.requestedWork}
                    </div>
                  </TableCell>
                  <TableCell>
                    <div className='pre'>
                      {isDisplayMode ? (
                        <Link
                          size='small'
                          variant='underlined'
                          onClick={() => {
                            navigate(row.no || '')
                          }}
                          disabled={!hasWoPermissions}
                        >
                          {row.no}
                        </Link>
                      ) : (
                        row.no
                      )}
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      ) : (
        <Typography>{t('9500055')}</Typography>
      )}
    </>
  )
}

export default TechlogWorkorders
